<template>
  <div id="hero" class="relative w-full h-full full-height group transition-all duration-700">
    <div class="container-hero"
        :style="`background-image: url('${config.public.cdnUrl+config.public.cdnFolder+dataSlider[0].img_src}');`"
        >
          <div v-if="isLargeScreen" class="absolute top-0 w-full h-full gradient-color-1 mix-blend-normal"></div>
          <div v-if="!isLargeScreen" class="lg:hidden absolute top-0 w-full h-full gradient-color-1-mobile mix-blend-normal"></div>
          <div v-if="isLargeScreen" class="absolute top-0 w-full h-full gradient-color-2 mix-blend-normal"></div>
          <div class="absolute top-6 right-3 md:top-[14%] md:right-[2.4%] opacity-40"><VectorSingleArrow color="ip-color-3" class="big-arrow max-w-48 lg:max-w-full w-full h-full" /></div>
          <div class="absolute top-0 w-full h-full shadow-top z-1"></div>
          <div class="relative z-3 w-full h-full flex items-center container-1">
            <div class="text-white space-y-6 md:space-y-10">
              <div class="space-y-3 md:space-y-6 lg:space-y-5 mb-10 sm:max-w-md lg:max-w-[40vw]">
                <div class="hero-text-content figtree font-bold w-fit text-white text-2xl lg:text-[3vw] xl:text-[2.5vw] leading-[1.35]">
                  {{dataSlider[0].caption1[lang]}}
                </div>
                <!-- <div v-if="dataSlider[0].caption2[lang]" class="hero-text-content w-fit text-2xl md:text-[2.5rem] font-bold lg:font-extrabold text-c-yellow">{{dataSlider[0].caption2[lang]}}</div> -->
                <div class="hero-text-content text-white whitespace-pre-wrap lg:max-w-[32vw]">
                  <div class="figtree font-medium text-base lg:text-[1.3vw] xl:text-[1.1vw] leading-7 md:leading-[2vw] lg:leading-[1.8vw]" v-html="dataSlider[0].caption3[lang]"></div>
                </div>
              </div>
              <div class="hero-text-content w-fit">
                  <NuxtLink
                    class="figtree arrow-hover rounded-[30px] h-full py-2 px-3 lg:py-3 lg:px-6 w-fit bg-white hover:bg-ip-color-3 hover:shadow-lg font-semibold text-base md:text-[1.4vw] lg:text-[1.1vw] text-ip-color-3 hover:text-ip-color-2 flex items-center gap-1 transition-colors duration-300"
                    :to="({ name: dataSlider[0].url.path })">
                    {{dataSlider[0].url.name[lang]}} <span class="w-0 h-0 scale-0">Details</span>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-5 h-5 arrow-btn transition-transform duration-300">
                        <path fill-rule="evenodd" d="M4.22 11.78a.75.75 0 0 1 0-1.06L9.44 5.5H5.75a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0V6.56l-5.22 5.22a.75.75 0 0 1-1.06 0Z" clip-rule="evenodd" />
                      </svg>
                  </NuxtLink>
              </div>
            </div>
          </div>
      </div>
    <div v-if="carbonBadge" class="absolute md:hidden bottom-6 md:bottom-16 left-3 md:left-auto md:right-8 width-[237px] rounded-[10px] z-10 bg-white bg-opacity-50 backdrop-blur-sm">
      <div v-html="carbonBadge"></div>
    </div>
  </div>
</template>

<script setup>
 
 
const lang = ref('id')
const emits = defineEmits(['onLoaded']);
 
const dayjs = useDayjs();
const navbarStore = useNavbarStore();
const { scrolled } = storeToRefs(navbarStore);
const isLargeScreen = useMediaQuery('(min-width: 1024px)');
const config = useRuntimeConfig();

const props = defineProps({
  dataSlider: {
    type: Object,
    required: false,
    default: () => {},
  },

});

const { $anime } = useNuxtApp();
const { carbonBadge } = storeToRefs(navbarStore);
onMounted(async () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  // // console.log(vh);
  const imgs = [];
  if (props.dataSlider && props.dataSlider.length > 0) {
    props.dataSlider?.forEach((slide) => {
      imgs.push(config.public.cdnUrl+config.public.cdnFolder+slide.img_src);
    });
    preload(imgs);
  }
});

const images = [];
const imageLoadedTotal = ref(0);
const preload = (imgs) => {
  for (let i = 0; i < imgs.length; i++) {
    images[i] = new Image();
    images[i].src = imgs[i];
    images[i].addEventListener('load', handleLoad);
  }
};
const handleLoad = async (e) => {
  imageLoadedTotal.value++;
};

watch(() => imageLoadedTotal.value, (value) => {
  if (value > 0) {
    emits('onLoaded');
  }
});

</script>

<style lang="scss" scoped>
.arrow-hover:hover > .arrow-btn{
  @apply translate-x-1;
}

.container-hero {
  width: 100%;
  height: 100%;

  background: #f2f2f2;
  display: flex;
  justify-content: center;
  align-items: center;

  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  object-fit: cover;
  position: relative;

  @apply cursor-default bg-center object-cover h-full w-full bg-no-repeat;
}

.gradient-color-1{
  background: rgb(49,49,135);
  background: linear-gradient(-90deg, rgba(49,49,135,0) 0%, rgba(18,18,52,.85) 100%);
}
.gradient-color-1-mobile{
  background: rgb(49,49,135);
  background: linear-gradient(90deg, rgba(18,18,52,.85) 10%, rgba(49,49,135,.45) 80%, rgba(49,49,135,0) 100%);
}

.gradient-color-2{
  background: rgb(49,49,135);
  background: linear-gradient(180deg, rgba(49,49,135,0) 0%, rgba(18,18,52,.85) 100%);
}
.shadow-top {
  background: rgb(0,0,0);
  background: -moz-linear-gradient(0deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0) 73%, rgba(0,0,0,.25) 100%);
  background: -webkit-linear-gradient(0deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0) 73%, rgba(0,0,0,.25) 100%);
  background: linear-gradient(0deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0) 73%, rgba(0,0,0,.25) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#fcd400",endColorstr="#fcd400",GradientType=1);
}
</style>
